import { CDK_DRAG_CONFIG } from "@angular/cdk/drag-drop";

const DragConfig = {
  dragStartThreshold: 0,
  pointerDirectionChangeThreshold: 5,
  zIndex: 10000,
};

export const cdkDragConfigProvider = {
  provide: CDK_DRAG_CONFIG,
  useValue: DragConfig,
};
